const messages = {
    enrollments: {
        group: "Group",
        student: "Student",
        showRejected: "Show rejected",
        showHiddenGroups: "Show hidden groups",
        showNotAddedVk: "Show not added to VK",
        showNotPaid: "Highlight not fully paid",
        showWasAtMeeting: "Show who was at the meeting",
        fully: "fully",
        noGroups: "There's no groups at this moment",
        deleteGroupConfirmation: "Are you sure you want to delete group {0}?",
        deleteCommentConfirmation: "Are you sure you want to delete comment {0}?",
        deleteDiscountConfirmation: "Are you sure you want to delete discount \"{0}\"?",
        needFillComment: "Comment is required",
        contactsAlreadyExist: "There are already such contact details: {0}",
        noMessages: "No messages",
        addToVk: "Add to VK group",
        removeFromVk: "Remove from VK group",
        markAsUnderCall: "Mark as not answered",
        removeUnderCall: "Remove not answered mark",
        markAsWasAtMeeting: "Mark that was present",
        removeWasAtMeeting: "Remove was present mark",
        comment: "Enrollment comment",
        fullName: "Full name",
        nameLabel: "N",
        phone: "Phone",
        email: "Email",
        vk: "VK",
        source: "Enrollment source",
        test: "Test",
        payment: "Payment",
        groupsAreNotLoaded: "Groups are not loaded yet. To download courses click \"Search\" or select a group from the lists below",
        language: "Lang.",
        city: "City",
        vkCityName: "City VK",
        isMainGroupMember: "Added to public group",
        isGroupMember: "Added to group",
        addedRejected: "Added rejected",
        addedNotFromGroup: "Added not from group",
        addedUnknown: "Added unknown",
        company: "Company",
        messagesTemplates: "Messages templates",
        applyTemplate: "Apply template",
        showFromAnotherCities: "Show from another сities",
        otherCities: "Other cities",
        hasCompany: "Has company",
        deadline: "Deadline",
        showDeadline: "Show deadline",
        endDateNotSet: "End date of course group is not set"
    },
    common: {
        search: "Search",
        clear: "Clear",
        confirmDelete: "Confirm delete",
        confirmAdd: "Confirm add",
        dataSuccessfullyDeleted: "Data successfully deleted.",
        dataSuccessfullySaved: "Data successfully saved.",
        loading: "Loading...",
        unknown: "Unknown",
        save: "Save",
        cancel: "Cancel",
        add: "Add",
        comment: "Comment",
        edit: "Edit",
        delete: "Delete",
        confirm: "Confirm",
        unconfirm: "Remove confirmation",
        create: "Create",
        hide: "Hide",
        show: "Show",
        date: "Date",
        sum: "Amount",
        ok: "OK",
        close: "Close",
        enterSymbols: "Please enter at least {0} symbols",
        noMatches: "No matches found",
        listEmpty: "List is empty",
        nMatchesAllowed: "You can select no more than {0} items",
        roubles: "RUR",
        copy: "Copy",
        copied: "Copied!",
        deleteItem: "Are you sure you want to delete this item?",
        yes: "Yes",
        no: "No",
        details: "Details",
        actions: "Actions",
        incorrectUrl: "Incorrect url",
        totalCount: "Total count",
        select: "Select",
        applyFilters: "Apply filters",
        clearFilters: "Clear filters",
        pageNavigation: "Page navigation",
        toPreviousPage: "To previous page",
        toNextPage: "To next page",
        toFirstPage: "To first page",
        toLastPage: "To last page",
        messageTemplateNotSelected: "Message template not selected",
        messageTemplateNotFound: "Message template not found",
        errorMessageTemplate: "Error in message template",
        advancedSearch: "Advanced search",
        time: "Time",
        reset: "Reset"
    },
    groups: {
        create: "Creating group",
        edit: "Editing group",
        name: "Name",
        courseType: "Course type",
        startDate: "Meeting date",
        firstLessonDate: "First lesson date",
        lastLessonDate: "Last lesson date",
        endDate: "Finish date",
        teacher: "Teacher",
        price: "Price",
        downloadExcel: "Download as Excel",
        downloadExcelForImport: "Export enrollments",
        downloadRecommendationAsExcel: "Download recommendations",
        downloadPaymentsAsExcel: "Download payments as Excel",
        downloadExcelAttendanceForm: "Download attendance form",
        downloadExcelFeedbackForm: "Download feedback form",
        total: "Total:",
        totalOk: "OK:",
        totalThinking: "Thinks:",
        totalRejected: "Rejected:",
        totalRejectedByUs: "We rejected:",
        totalLookingForSomethingElse: "Looking for something else:",
        totalSpam: "Spam:",
        totalUnderCalls: "Not answered:",
        addEnrollment: "Add enrollment",
        downloadContracts: "Download contracts",
        downloadPdfContracts: "Download contracts in PDF",
        downloadCertificates: "Download certificates",
        lessonsCount: "Lessons count",
        timetable: "Timetable",
        headTeacher: "Head teacher",
        performanceTable: "Performance table",
        columnsSettings: "Columns settings",
        needFillVkUrl: "Need fill VK url",
        needFillPerformanceTableUrl: "Need fill performance table url",
        mainChat: "Main chat",
        additionalChat: "Additional chat",
        downloadGroupList: "Download group list",
        copyGroupListToClipboard: "Copy list to clipboard",
        synchronizeWithVk: "Synchronize with VK",
        synchronize: "Synchronize",
        wrongUsersNotFound: "Wrong users not found",
        fullName: "Name",
        vkUrl: "VK URL",
        groupName: "Group name",
        groupVkUrl: "Group VK URL",
        removeVkUserReason: "Remove VK user reason",
        wrongUsers: "Wrong users",
        synchronized: "Synchronized"
    },
    editEnrollments: {
        editTitle: "Edit enrollment",
        createTitle: "Create enrollment",
        enrollmentTitle: "Enrollment",
        language: "Programming language",
        enrollmentStatus: "Enrollment status",
        recommendationLevel: "Recommendation Level",
        recommendation: "Recommendation",
        firstCommunicationDate: "Enrollment date",
        needFillField: "You must fill the field",
        underCall: "Not answered",
        confirmed: "Confirmed",
        vkAdded: "Added to VK",
        hasListenedCourse: "Has listened course",
        wasAtMeeting: "Was at the meeting",
        hasReview: "Wrote the review",
        studentType: "Student type",
        contacts: "Contact details",
        firstName: "First name",
        lastName: "Last name",
        middleName: "Middle name",
        hasNotMiddleName: "Has not middle name",
        age: "Age",
        gender: "Gender",
        male: "Male",
        female: "Female",
        otherContacts: "Other contacts",
        rating: "Rating",
        ratingHelp: "1 - max, 4 - min",
        notSpecified: "No",
        needContact: "You must fill in any contact",
        communicationHistory: "Communication history",
        studentData: "Student details",
        testType: "Test type",
        testResult: "Test result",
        noDiscounts: "No discounts",
        discountType: "Discount type",
        discounts: "Discounts",
        friend: "Friend",
        unusedFriendDiscounts: "Unused discounts for friends",
        friendDiscount: "Discount for bringing a friend",
        fromFriendDiscount: "Discount from a friend",
        courseFeedback: "Course feedback",
        courseFeedbackPlan: "Course feedback plan",
        contract: "Contract",
        downloadContract: "Download contract",
        downloadPDFContract: "Download contract in PDF",
        downloadStudentContracts: "Download user contracts",
        downloadPdfStudentContracts: "Download user contracts in PDF",
        certificate: "Certificate",
        downloadCertificate: "Download certificate",
        payerType: "Payer type",
        payerFullName: "Payer full name",
        downloadCertificateWithSignatures: "Download certificate with signatures",
        jobOffers: "Job offers",
        company: "Company",
        profession: "Profession",
        programmingArea: "Programming area",
        internship: "Internship",
        jobOfferDate: "Job offer date",
        site: "Site",
        comment: "Comment",
        vkCityName: "City VK",
        isGroupMember: "Added to public group",
        addedToPublicVkGroup: "Added to public VK group",
        didNotCall: "Didn't call",
        possiblyTesting: "Possibly testing",
        callAboutTest: "Call about the test",
        noTelegram: "No Telegram",
        noWhatsApp: "No WhatsApp",
        extraTime: "Extra time",
        timeUnit: "Time unit",
        noExtraTimes: "No extra time",
        twoWeeks: "Two weeks",
        oneMonth: "One month",
        addFromEmail: "Add from email",
        emailTextOrPhoneNumber: "Email text or phone number",
        requiredFieldsAreMissing: "Required fields are missing",
        cyrillicLetters: "Cyrillic letters aren't allowed",
        extraTimeReason: "Extra time reason",
        birthDate: "Birth date",
        resume: "Resume",
        telegram: "Telegram",
        doNotAddToRecommendations: "Do not add to recommendations",
        overpayment: "Overpayment",
        unusedOverpaymentDiscounts: "Unused overpayment discounts",
        schoolchild: "Schoolchild",
        student: "Student",
        offer: "Offer",
        offerForFriends: "Offer for friends",
        doesNotPlan: "Does not plan"
    },
    editPayments: {
        title: "Edit payments",
        price: "Course full price:",
        specialPrice: "Special price:",
        specialPriceReason: "Special price reason",
        totalPaid: "Total paid:",
        totalRefunded: "Total refunded:",
        totalAmount: "Total amount:",
        date: "Payment date",
        method: "Payment method",
        discountPrice: "Discount price:",
        friendDiscount: "Discount for bringing a friend ({0}) - {1} RUR",
        fromFriendDiscount: "Discount from a friend ({0}) - {1} RUR",
        unpaid: "Remaining amount:",
        addPayment: "Add payment",
        addRefund: "Add refund",
        payments: "Payments",
        refunds: "Refunds",
        refundDate: "Refund date",
        refundMethod: "Refund method",
        overpayment: "Overpayment:"
    },
    editTestScore: {
        notDone: "not done",
        wrong: "wrong",
        title: "Edit test score",
        score: "Test score",
        enterDetails: "Enter details",
        clear: "Clear test results",
        answer: "Answer:"
    },
    messages: {
        title: "Messages sending",
        theme: "Subject",
        message: "Message",
        attachFiles: "Attach files",
        additionalAddresses: "Additional email recipients",
        studentsWithEmails: "Students with email",
        studentsWithoutEmails: "Students without email, with VK",
        studentsWithoutEmailsWithoutVk: "Students without email, without VK",
        sendEmails: "Send to email",
        sendVk: "Send to VK",
        emailsSending: "Email",
        vkSending: "VK",
        sendingType: "Send type",
        noAddresses: "No address to send",
        sendingFailed: "Failed to send letters to the following addresses:",
        sendingFailedVk: "Failed to send messages to the following VK addresses:",
        sendingStarted: "Emails sending started",
        sendingDone: "Emails successfully sent",
        vKSendingDone: "VK messages successfully sent",
        dropzoneDefaultMessage: "Drop files here to upload",
        dropzoneRemoveFile: "Remove file",
        dropzoneCancelUpload: "Cancel upload",
        uploadingError: "Error uploading file {0}",
        additionalAddressesHelp: "Specify additional addresses separated by commas or semicolons",
        additionalVkAddressesHelp: "Specify additional links to VK separated by commas or semicolons, for example: https://vk.ru/durov",
        filesSizeIsBig: "The total size of the files should not exceed 25 MB",
        someFilesLost: "Some attachments are lost on the server. Please upload them again.",
        enterCaptcha: "Enter the code",
        needCaptcha: "Enter the captcha",
        clearAfterSending: "Clear form after successful sending",
        uncheckStudentsWithoutTest: "Uncheck students without test"
    },
    signalR: {
        courseGroupCreated: "User \"{1}\" created course group \"{0}\"",
        courseGroupCreatedSelf: "You created course group \"{0}\"",
        courseGroupUpdated: "User \"{1}\" updated course group \"{0}\"",
        courseGroupUpdatedSelf: "You updated course group \"{0}\"",
        courseGroupDeleted: "User \"{1}\" deleted course group \"{0}\"",
        courseGroupDeletedSelf: "You deleted course group \"{0}\"",
        enrollmentCreated: "User \"{1}\" created enrollment \"{0}\"",
        enrollmentCreatedSelf: "You created enrollment \"{0}\"",
        enrollmentUpdated: "User \"{1}\" updated enrollment \"{0}\"",
        enrollmentUpdatedSelf: "You updated enrollment \"{0}\"",
        enrollmentUpdatedJob: "Enrollment \"{0}\" updated",
        enrollmentDeleted: "User \"{1}\" deleted enrollment \"{0}\"",
        enrollmentDeletedSelf: "You deleted enrollment \"{0}\"",
        paymentsUpdated: "User \"{1}\" updated payments of enrollment \"{0}\"",
        paymentsUpdatedSelf: "You updated payments of enrollment \"{0}\"",
        testScoreUpdated: "User \"{1}\" updated test score of student \"{0}\"",
        testScoreUpdatedSelf: "You updated test score of student \"{0}\"",
        messageTemplateCreated: "Message template \"{0}\" was created",
        messageTemplateUpdated: "Message template \"{0}\" was updated",
        messageTemplateDeleted: "Message template \"{0}\" was deleted"
    },
    lastPayments: {
        programming: "Programming",
        testing: "Testing",
        student: "Student",
        sum: "Paid",
        paymentType: "Payment type",
        totalForPeriod: "Total for the period",
        allPeriodPaymentsSum: "Sum of payments for the period",
        dayPaymentsSum: "Day payments sum",
        cash: "Cash",
        site: "Site",
        bankTransfer: "Bank transfer",
        notLoaded: "Failed to load last payments.",
        noPayments: "No payments lately.",
        startDate: "Start date",
        endDate: "End date",
        date: "Date",
        dateType: "Date type",
        period: "Period",
        dayPaymentsCount: "Day payments count",
        allPeriodPaymentsCount: "Count of payments for the period"
    },
    statistics: {
        startDate: "Start date",
        endDate: "End date",
        testActive: "Test active",
        testFailed: "Test failed",
        programmingActive: "Programming active",
        programmingFailed: "Programming failed",
        monday: "Mo",
        tuesday: "Tu",
        wednesday: "We",
        thursday: "Th",
        friday: "Fr",
        saturday: "Sa",
        sunday: "Su",
        total: "Total",
        notRejectedEnrollmentsCount: "Not rejected enrollments count",
        profit: "Profit",
        noData: "NoData",
        profitByMonths: "Profit by months",
        profitByYears: "Profit by years",
        profitStatistics: "Profit statistics",
        months: "Months",
        years: "Years",
        groupsNotFound: "Groups not found",
        gender: "Gender",
        men: "Men",
        women: "Women",
        notSpecified: "Not specified",
        age: "Age",
        city: "City",
        programmingLanguage: "Programming language",
        fromFriend: "From friend",
        source: "Source",
        enrollmentsStatistics: "Enrollments statistics",
        newEnrollments: "New enrollments",
        group: "Group",
        active: "Active",
        all: "All",
        rejected: "Rejected",
        enrollmentStatus: "Enrollment status",
        aggregatedStudentSource: "Aggregated student source",
        needSelectGroup: "Need select group",
        noDataForThisGroup: "No data for this group",
        enrollmentsNotFound: "Enrollments not found",
        "new": "New",
        old: "Old",
        averageAge: "Average age",
        studentType: "Student type"
    },
    courseFeedback: {
        feedback: "Feedback",
        feedbackPlan: "Feedback plan",
        editFeedback: "Edit feedback",
        groupsAreNotLoaded: "Select a group",
        editRecommendation: "Edit recommendation",
        showWithoutFeedback: "Show without feedback",
        hideFeedback: "Hide feedback",
        withoutFeedback: "Without feedback",
        listenedCourse: "Listened course",
        strongestRecommendationStudents: "Strongest recommendation",
        strongRecommendationStudents: "Strong recommendation",
        goodRecommendationStudents: "Good recommendation",
        withoutRecommendationStudents: "Without recommendation",
        successfullyCompletedCourse: "Successfully completed course",
        studentsCount: "Students count",
        liked: "Liked",
        notLiked: "Not liked",
        likedCourse: "Liked the course",
        didNotLikeCourse: "Didn't like the course",
        willWriteReview: "Will write review",
        willNotWriteReview: "Won't write review",
        feedbackNotAsked: "Feedback didn't asked",
        noImprovements: "No improvements",
        haveImprovements: "Have improvements",
        improvements: "Improvements",
        time: "Time",
        hoursPerWeek: "Hours per week",
        plans: "Plans",
        noPlans: "No plans",
        no: "No",
        add: "Add",
        other: "Other",
        winter: "In winter",
        spring: "In spring",
        summer: "In summer",
        autumn: "In autumn",
        takeCourseAgain: "Take the course again",
        thinks: "Thinks",
        meetingOnly: "Meeting only",
        ifPassTasks: "If passes all the tasks",
        ifDoNotPassTasks: "If do not pass all the tasks",
        addToGroups: "Add to groups",
        offer: "Offer",
        groupAlreadySelected: "Group already selected",
        groupNotSelected: "Group not selected",
        showComment: "Show comment",
        hasJobOffers: "Has job offers",
        hasCompanies: "Has companies",
        doNotAddToRecommendations: "Do not add to recommendations"
    },
    logs: {
        startTime: "Start time",
        endTime: "End time",
        levelsFilter: "Level filter",
        level: "Filter",
        substringInText: "Substring in the text",
        timeColumn: "Time",
        levelColumn: "Level",
        textColumn: "Text",
        noLogs: "There are no posts matching your search criteria",
        downloadLogs: "Download all logs",
        filterAll: "All logs",
        filterNotLess: "Level >=",
        filterNotHigher: "Level <=",
        filterEqual: "Level equals",
        caseSensitive: "Case sensitive"
    },
    rolesManagement: {
        name: "Role name",
        usersCount: "Users count",
        createRole: "Create role",
        editRole: "Edit role",
        deleteRoleConfirmation: "Are you sure you want to delete role \"{0}\"?",
        roleUsers: "Users in role \"{0}\"",
        userName: "User name",
        noRoleUsers: "No users in role",
        deleteUserFromRoleConfirmation: "Are you sure you want to delete user \"{0}\" from role \"{1}\"?",
        addUserToRoleConfirmation: "Are you sure you want to add user \"{0}\" to role \"{1}\"?"
    },
    usersManagement: {
        name: "User name",
        email: "Email",
        userNameOrEmail: "User name or email",
        emailConfirmed: "Email confirmed",
        userDetails: "Details of user \"{0}\"",
        phoneNumber: "Phone number",
        phoneNumberConfirmed: "Phone number confirmed",
        accessFailedCount: "Access failed count",
        lockoutEnabled: "Lockout enabled",
        isLockedOut: "Is locked out",
        lockoutEnd: "Lockout end",
        twoFactorEnabled: "Two factor enabled",
        createUser: "Create user",
        userRoles: "User roles",
        rolesOfUser: "Roles of user \"{0}\"",
        noUserRoles: "User has not roles",
        deleteUserConfirmation: "Are you sure you want to delete user \"{0}\"?",
        password: "Password",
        confirmPassword: "Confirm password",
        changePassword: "Change password",
        changePasswordOfUser: "Change password of user \"{0}\"",
        setLockout: "Set lockout",
        setLockoutForUser: "Set lockout for user \"{0}\"",
        search: "Search"
    },
    costCalculation: {
        paymentsSum: "All payments sum",
        cashPaymentsSum: "Cash payments sum",
        sitePaymentsSum: "Site payments sum",
        bankTransferPaymentsSum: "Bank transfer payments sum",
        needToPay: "Need to pay",
        totalCourseCost: "Total course cost",
        fullPayment: "Full payment",
        fullName: "Full name",
        sum: "Sum",
        rejected: "Rejected",
        notPaidCount: "Not Paid Count",
        fullPaidRejectedCount: "Full paid rejected count",
        studentsInGroupCount: "Students in group count",
        rejectedStudentsInGroupCount: "Rejected students in group count",
        totalStudentsInGroupCount: "Total students in group count",
        leftToPay: "Left to pay",
        refundsCount: "Refunds count",
        refundsSum: "All refunds sum",
        totalSum: "All payments sum including refunds",
        payment: "Payment",
        refund: "Refund",
        overpayment: "Overpayment",
        overpaymentsSum: "Overpayments sum",
        totalCourseCostTooltip: "Not rejected enrollments cost + rejected payments sum - rejected refunds sum",
        totalSumTooltip: "All payments sum - refunds sum",
        paymentsSumTooltip: "All payments sum",
        someCourseHasFullPayment: "Full payment",
        anyCoursesHasNoPayments: "No payment",
        partialPaymentCoursesAndEnrollmentNotRejected: "Partially payment and not rejected enrollment",
        partialPaymentCoursesAndEnrollmentRejected: "Partially payment and rejected enrollment"
    },
    messagesTemplates: {
        tags: "Tags",
        enrollmentId: "Enrollment id",
        sourceId: "Source id",
        addedToVk: "Added to VK",
        sourceName: "Source name",
        courseSubType: "Course subtype",
        notAnswered: "Not answered",
        recommendationComment: "Recommendation comment",
        companyId: "Company id",
        companyName: "Company name",
        companySiteUrl: "Company site URL",
        companyComment: "Company comment",
        paymentId: "Payment id",
        paymentSum: "Payment sum",
        refundSum: "Refund sum",
        refundType: "Refund type",
        studentId: "Student id",
        isMale: "Is male",
        vkUrl: "VK url",
        vkId: "VK id",
        vkScreenName: "VK screen name",
        comments: "Сomments",
        cityId: "City id",
        cityName: "City name",
        novosibirskOffset: "Novosibirsk offset",
        courseGroupId: "Course group id",
        discountId: "Discount id",
        discountSum: "Discount sum",
        discountComment: "Discount comment",
        friendId: "Friend id",
        friend: "Friend",
        discountRestriction: "Discount restriction",
        percent: "Discount percent",
        isActiveDiscount: "Active discount",
        discountName: "Discount name",
        extraTimes: "Extra times",
        extraTimeId: "Extra time id",
        courseGroupText: "Course group text",
        courseGroupIsHidden: "Course group hidden",
        courseGroupName: "Course group name",
        name: "Tag name",
        description: "Description",
        documentation: "Documentation"
    },
    progressTable: {
        tableUrl: "Table URL",
        student: "Student",
        search: "Search",
        students: "Students",
        notCompletedTasks: "Not completed tasks",
        needFillField: "You must fill the field",
        lessonsCount: "Lessons count",
        urlNotSet: "URL not set",
        tasksCount: "Tasks count",
        totalTasks: "Total tasks",
        attendance: "Attendance",
        completed: "Completed",
        partiallyCompleted: "Partially completed",
        notSent: "Not sent",
        sent: "Sent",
        notCompleted: "Not completed",
        attemptsCountAverage: "Average attempts",
        attended: "Attended",
        notAttended: "Not attended",
        comment: "Comment"
    },
    taxRefund: {
        student: "Student",
        birthDateNotSpecified: "Birth date not specified",
        year: "Year",
        tin: "TIN",
        passportSeries: "Passport series",
        passportNumber: "Passport number",
        passportIssueDate: "Passport issue date",
        payerDoesNotMatchStudent: "Payer does not match student",
        firstName: "First name",
        lastName: "Last name",
        middleName: "Middle name",
        birthDate: "Birth date",
        downloadCertificate: "Download certificate",
        payerInfo: "Payer info",
        correctionNumber: "Correction number",
        studentTin: "Student TIN",
        studentPassportSeries: "Passport series",
        studentPassportNumber: "Passport number",
        studentPassportIssueDate: "Passport issue date",
        payerTin: "Payer TIN",
        payerPassportSeries: "Passport series",
        payerPassportNumber: "Passport number",
        payerPassportIssueDate: "Passport issue date",
        noAmountAvailableForRefundForSelectedYear: "No amount available for refund for the selected year",
        enterPassportDetails: "Enter passport details"
    }
};

export default messages;